export default {"src":"/_next/static/media/homebuildcalc.3f82b9f7.svg","height":89,"width":89,"blurWidth":0,"blurHeight":0};